import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { Cms } from '@impact/data';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeatureDetectionService } from '../../utils/helpers/feature-detection.service';
import { NavigationService } from '../navigation.service';

@Component({
    selector: 'app-page-secondary-navigation',
    templateUrl: './page-secondary-navigation.component.html',
})
export class PageSecondaryNavigationComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    private unsubscribe = new Subject<void>();

    @Input() navigationData: Cms.NavigationDto;
    @ViewChildren('listElement') listElements: QueryList<ElementRef>;

    currentRouteUrl: string;

    constructor(
        private featureDetectionService: FeatureDetectionService,
        private navigationService: NavigationService
    ) {}

    ngOnInit() {
        this.navigationService.currentUrl$
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((url: string) => {
                this.currentRouteUrl = url;
            });
    }

    ngAfterViewInit() {
        const index = this.navigationData.children.findIndex(
            (c) => c.url === this.currentRouteUrl
        );

        if (index > 0) {
            this.scrollToListItem(index);
        }
    }

    scrollToListItem(index: number): void {
        if (!this.listElements && index !== -1) {
            return;
        }

        if (this.featureDetectionService.isBrowser()) {
            const elementsArray = this.listElements.toArray();
            const element: HTMLElement = elementsArray[index].nativeElement;
            const parentElement = element.parentElement;

            if (parentElement) {
                let scrollDistance: number;

                if (index + 2 === elementsArray.length) {
                    scrollDistance = parentElement.offsetWidth;
                } else {
                    scrollDistance =
                        element.offsetLeft -
                        parentElement?.scrollLeft -
                        parentElement.offsetWidth / 2 +
                        element.offsetWidth;
                }

                parentElement?.scrollBy({
                    top: 0,
                    left: scrollDistance,
                    behavior: 'smooth',
                });
            }
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
